import { IApplicationState } from 'shared/types/redux';
import { ILandingState } from 'shared/types/features';

export const selectIsLifeInsuranceEnabled = (state: IApplicationState): ILandingState['isLifeInsuranceEnabled'] =>
  state.landing.isLifeInsuranceEnabled;
